// Admin
export const USER_LOGIN_URL = '/login'
export const USER_LOAD_URL = '/profile/admin/profile_details'
export const CLUB_LOAD_URL = '/profile/club/profile_details'
export const USER_LOGOUT_URL = '/logout'
export const USER_PROFILE_UPDATE_URL = '/profile/admin/update'
export const USER_PASSWORD_CHANGE_URL = '/password/change_password'
export const USER_FORGOT_PASSWORD_URL = '/password/forgot_password'
export const REFRESH_TOKEN_URL = '/token'

// Club
export const CLUB_LIST_URL = '/admin/clubs/all'
export const CLUB_CREATE_URL = '/admin/clubs/create'
export const CLUB_UPDATE_URL = '/admin/clubs/update'
export const CLUB_DELETE_URL = '/admin/clubs/delete'
export const CLUB_ONE_URL = '/admin/clubs/one'
export const CLUB_GRAND_TOTAL_URL =
    '/clubs/club-nembership/admin/purchased-membership-by-club/grand-total'
export const CLUB_PUBLISH_URL = '/admin/clubs/update-publish'

// SETUP FEE
export const SETUP_FEE_LIST_URL = '/clubs/membership-fee-config/admin/all'
export const SETUP_FEE_CREATE_URL = '/clubs/membership-fee-config/admin/create'
export const SETUP_FEE_UPDATE_URL = '/clubs/membership-fee-config/admin/update'
export const SETUP_FEE_DELETE_URL = '/clubs/membership-fee-config/admin/delete'
export const SETUP_FEE_ONE_URL = '/clubs/membership-fee-config/admin/one'

// Club Plans

export const CLUB_PLANS_LIST = '/clubs/membership-fee-config/membership-plan'

/// Plans
export const PLAN_LIST_URL = '/clubs/club-nembership/admin/purchased-membership-by-club'
export const PLAN_CREATE_URL = '/clubs/club-nembership/admin/add-membership-to-club'
export const MEMBERSHIP_PLAN_LIST = '/clubs/membership-fee-config/membership-plan'

// Processing Fees

export const MEMBERSHIP_PROCESSING_FEES_CREATE_URL =
    '/clubs/membership-profit-processing-fee/admin/create'
export const MEMBERSHIP_PROCESSING_FEES_UPDATE_URL =
    '/clubs/membership-profit-processing-fee/admin/update'
export const MEMBERSHIP_PROCESSING_FEES_LIST_URL =
    '/clubs/membership-profit-processing-fee/admin/all'

export const SWEEPSTAKE_VARIETY_LIST_LIST = ''
export const SWEEPSTAKE_VARIETY_LIST_CREATE = ''
export const SWEEPSTAKE_VARIETY_LIST_ONE = ''
export const SWEEPSTAKE_VARIETY_LIST_UPDATE = ''
export const SWEEPSTAKE_VARIETY_LIST_DELETE = ''
export const SWEEPSTAKE_VARIETY_LIST_PUBLISH_STATUS = ''

// Sanction Processing fees
export const SANCTION_PROCESSING_FEES_CREATE_URL =
    '/clubs/sanction-profit-processing-fee/admin/create'
export const SANCTION_PROCESSING_FEES_LIST_URL = 'clubs/sanction-profit-processing-fee/admin/all'
export const SANCTION_PROCESSING_FEES_UPDATE_URL =
    '/clubs/sanction-profit-processing-fee/admin/update'

/////

export const GET_ALL_SANCTION_FEES_CONFIG_URL = '/clubs/sanction/fee-config/all'
export const GET_ONE_SANCTION_FEES_CONFIG_URL = '/clubs/sanction/fee-config/one'
export const CREATE_SANCTION_FEES_CONFIG_URL = '/clubs/sanction/fee-config/create'
export const UPDATE_SANCTION_FEES_CONFIG_URL = '/clubs/sanction/fee-config/update'
export const DELETE_SANCTION_FEES_CONFIG_URL = '/clubs/sanction/fee-config/delete'

export const GET_ALL_MEMBER_FEES_CONFIG_URL = '/clubs/membership/fee-config/all'
export const GET_ONE_MEMBER_FEES_CONFIG_URL = '/clubs/membership/fee-config/one'
export const CREATE_MEMBER_FEES_CONFIG_URL = '/clubs/membership/fee-config/create'
export const UPDATE_MEMBER_FEES_CONFIG_URL = '/clubs/membership/fee-config/update'
export const DELETE_MEMBER_FEES_CONFIG_URL = '/clubs/membership/fee-config/delete'

export const GET_ALL_REVENUE_BREAK_DOWN_LIST =
    '/clubs/order/admin/membership-order/membership-revenue-list'
export const GET_ALL_REVENUE_BREAK_DOWN_CLUB_LIST = '/clubs/order/admin/membership-order/club-list'
export const GET_ALL_REVENUE_BREAK_DOWN_USER_LIST_BY_CLUB =
    '/clubs/order/admin/membership-order/user-list'
export const REVENUE_BREAK_DOWN_GRAND_TOTAL = '/clubs/order/admin/membership-order/grand-total'


export const GET_ALL_SANCTION_REVENUE_BREAK_DOWN_LIST =
    'club/sanction-order/admin/sanction-order/sanction-revenue-list'
export const GET_ALL_SANCTION_REVENUE_BREAK_DOWN_CLUB_LIST = '/club/sanction-order/admin/sanction-order/club-list'
export const GET_ALL_SANCTION_REVENUE_BREAK_DOWN_USER_LIST_BY_CLUB =
    '/club/sanction-order/admin/sanction-order/user-list'
export const SANCTION_REVENUE_BREAK_DOWN_GRAND_TOTAL = '/club/sanction-order/admin/sanction-order/grand-total'

// How to document
export const GET_ALL_HOW_TO_DOCUMENT_CATEGORY_LIST = '/how-to-club-data/category/all'
export const CREATE_HOW_TO_DOCUMENT_CATEGORY = '/how-to-club-data/category/create'
export const GET_ONE_HOW_TO_DOCUMENT_CATEGORY = '/how-to-club-data/category/one'
export const UPDATE_HOW_TO_DOCUMENT_CATEGORY = '/how-to-club-data/category/update'
export const DELETE_HOW_TO_DOCUMENT_CATEGORY = 'how-to-club-data/category/delete'
export const PUBLISH_HOW_TO_DOCUMENT_CATEGORY = '/how-to-club-data/category/update-multiple'


export const GET_ALL_HOW_TO_DOCUMENT_SUB_CATEGORY_LIST = '/how-to-club-data/sub-category/all'
export const CREATE_HOW_TO_DOCUMENT_SUB_CATEGORY = '/how-to-club-data/sub-category/create'
export const UPDATE_HOW_TO_DOCUMENT_SUB_CATEGORY = '/how-to-club-data/sub-category/update'
export const DELETE_HOW_TO_DOCUMENT_SUB_CATEGORY = 'how-to-club-data/sub-category/delete'
export const PUBLISH_HOW_TO_DOCUMENT_SUB_CATEGORY = '/how-to-club-data/sub-category/update-multiple'
export const GET_ONE_HOW_TO_DOCUMENT_SUB_CATEGORY = '/how-to-club-data/sub-category/one'


export const GET_ALL_HOW_TO_DOCUMENT_LIST = '/how-to-club-data/documents/all'
export const CREATE_HOW_TO_DOCUMENT = '/how-to-club-data/documents/create'
export const UPDATE_HOW_TO_DOCUMENT = '/how-to-club-data/documents/update'
export const DELETE_HOW_TO_DOCUMENT = '/how-to-club-data/documents/delete'